// extracted by mini-css-extract-plugin
export default {"Marker":"styles_Marker__QumnH","inner":"styles_inner__4Y42W"};